import React, { useContext, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { ThemeContext } from "../../../context/ThemeContext";
import { Table, Pagination } from "rsuite";
import { SkipToken } from "@reduxjs/toolkit/dist/query";
import useTitle from "../../../hooks/useTitle";

import { useGetAcCompanyListQuery } from "../../../features/ac/acCompanyCreate";
import { useCreateAcCompanyMutation } from "../../../features/ac/acCompanyCreate";
import { useUpdateAcCompanyMutation } from "../../../features/ac/acCompanyCreate";

import { useGetPeripheralAssignListQuery } from "../../../features/ac/peripheralAssignApi";
import { useAssignPeripheralMutation } from "../../../features/ac/peripheralAssignApi";
import { useUpdateAssignedPeripheralMutation } from "../../../features/ac/peripheralAssignApi";

import { useGetAcBranchListQuery } from "../../../features/ac/acBranchCreate";
import { useGetAcPeripheralListQuery } from "../../../features/ac/acPeripheralCreate";
import { useGetDeviceConfigListQuery } from "../../../features/device-config/deviceConfigApi";

const { Column, HeaderCell, Cell } = Table;

function PeripheralAssign() {
  useTitle("Peripheral Assign");
  const [show, setShow] = useState(false);
  const [createFormSelector, setCreateFormSelector] = useState(true);
  const [updateFormData, setUpdateFormData] = useState({});
  const [reseponseMessage, setResponseMessage] = useState();
  const theme = useContext(ThemeContext);

  //   const { data: companyList, isLoading } = useGetAcCompanyListQuery();
  const [createAcCompany] = useCreateAcCompanyMutation();
  const [updateAcCompany] = useUpdateAcCompanyMutation();

  const { data: assignList, isLoading } = useGetPeripheralAssignListQuery();

  const { data: branchList } = useGetAcBranchListQuery();
  const { data: peripheralList } = useGetAcPeripheralListQuery();
  const { data: deviceList } = useGetDeviceConfigListQuery();

  const [assignPeripheral] = useAssignPeripheralMutation();
  const [updateAssignedPeripheral] = useUpdateAssignedPeripheralMutation();

  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  let defaultData = [];
  let data = [];

  if (!isLoading) {
    if (assignList?.data) {
      defaultData = [...assignList.data];
      defaultData = defaultData?.map((alertInfo) => {
        const data = new Date(alertInfo.updated_at);
        const formattedDate = data.toLocaleString();
        return {
          ...alertInfo,
          updated_at: formattedDate,
        };
      });
    }

    data = defaultData?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  }

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };
  const handleEdit = (id) => {
    let formData = defaultData.find((object) => object.id == id) || {};
    setUpdateFormData(formData);
    // console.log(formData);
  };
  const handleModalOutsideClick = () => {
    setShow(false);
    setResponseMessage("");
  };
  const dataChangeHandler = (e) => {
    setResponseMessage("");
    setUpdateFormData((previousValue) => ({
      ...previousValue,
      [e.target.name]: e.target.value,
    }));
  };
  //for data table

  const formSubmitHandler = (e) => {
    e.preventDefault();
    if (createFormSelector) {
      assignPeripheral(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    } else {
      updateAssignedPeripheral(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  return (
    <div className={`row row-sm ${theme} `}>
      <div
        className="theme-text"
        style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "1rem" }}
      >
        Peripheral Assign
      </div>
      <div style={{ textAlign: "right", marginBottom: "1rem" }}>
        <button
          type="submit"
          className="btn btn-primary btn-md "
          // style={{ width: "20vw" }}
          onClick={() => {
            setShow(true);
            setCreateFormSelector(true);
            setUpdateFormData({});
          }}
        >
          Peripheral Assign
        </button>
        {/* </div> */}
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        classname={`${theme} `}
        centered
        onExited={handleModalOutsideClick}
      >
        <div className={`${theme}`}>
          <Modal.Header
            className="theme-background theme-text"
            style={{ borderRadius: "0px" }}
          >
            <Modal.Title>
              {createFormSelector ? "Peripheral Assign" : "Update Assign"}
            </Modal.Title>
            <div style={{ color: "green" }}>{reseponseMessage}</div>
            <RxCross2 onClick={handleModalOutsideClick} />
          </Modal.Header>
          <Modal.Body className="theme-background theme-text">
            {" "}
            <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 zero-padding">
              <div>
                <div>
                  <form onSubmit={formSubmitHandler}>
                    <div class="form-group">
                      <label class="form-label" for="premises no">
                        Select Device <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="device_id"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.device_id || ""}
                      >
                        <option label="Choose one"></option>
                        {deviceList?.data?.map((deviceInfo) => {
                          return (
                            <option value={deviceInfo?.id}>
                              {deviceInfo?.device_id}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div class="form-group">
                      <label class="form-label" for="premises no">
                        Select Branch <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="branch_id"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.branch_id || ""}
                      >
                        <option label="Choose one"></option>
                        {branchList?.data?.map((branchInfo) => {
                          return (
                            <option value={branchInfo?.id}>
                              {branchInfo?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div class="form-group">
                      <label class="form-label" for="premises no">
                        Select Peripheral{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="peripheral_id"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.peripheral_id || ""}
                      >
                        <option label="Choose one"></option>
                        {peripheralList?.data?.map((peripheralInfo) => {
                          return (
                            <option value={peripheralInfo?.id}>
                              {peripheralInfo?.type}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="form-group">
                      <label for="sensorName">
                        Start Reg Address{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Start Reg Address"
                        // value={name}
                        defaultValue={updateFormData?.start_reg_address || ""}
                        name="start_reg_address"
                        onChange={(e) => {
                          // setSensorName(e.target.value);
                          dataChangeHandler(e);
                        }}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label for="sensorName">
                        Area Zone <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Area Zone"
                        defaultValue={updateFormData?.area_zone || ""}
                        name="area_zone"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label for="sensorName">
                        Peripheral Number{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Peripheral Number"
                        defaultValue={updateFormData?.ac_number || ""}
                        name="ac_number"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label class="form-label" for="premises no">
                        Status<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="status"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.status || ""}
                      >
                        <option label="Choose one"></option>
                        <option value="on">On</option>
                        <option value="off">Off</option>
                      </select>
                    </div>

                    {/* <div className="form-group">
                      <label for="sendorId">Sensor Id</label>
                      <input
                        type="text"
                        name="sensor_id"
                        defaultValue={updateFormData?.sensor_id || ""}
                        onChange={(e) => {
                          setSensorId(e.target.value);
                          dataChangeHandler(e);
                        }}
                        className="form-control"
                        placeholder="Sensor Id"
                        readOnly={createFormSelector ? false : true}
                      />
                    </div> */}
                    <div style={{ textAlign: "center" }}>
                      <Button type="submit">Submit</Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <div>
        <div className="table-responsive theme-background theme-text">
          <Table
            height={500}
            data={data || []}
            loading={defaultData.length > 0 ? false : true}
          >
            <Column
              width={50}
              align="center"
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Id.</HeaderCell>
              <Cell dataKey="id" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Branch Name</HeaderCell>
              <Cell dataKey="branch_name" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>
                Peripheral Name
              </HeaderCell>
              <Cell dataKey="peripheral_name" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Area Zone</HeaderCell>
              <Cell dataKey="area_zone" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Ac Number</HeaderCell>
              <Cell dataKey="ac_number" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Status</HeaderCell>
              <Cell dataKey="status" />
            </Column>

            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Last Updated</HeaderCell>
              <Cell dataKey="updated_at" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Edit</HeaderCell>
              <Cell>
                {(rowData) => (
                  <div
                    icon="edit"
                    onClick={() => {
                      setShow(true);
                      setCreateFormSelector(false);
                      handleEdit(rowData.id);
                    }}
                  >
                    <FaEdit />
                  </div>
                )}
              </Cell>
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="lg"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={defaultData.length}
              limitOptions={[10, 30, 50]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PeripheralAssign;
